import clamp from "lodash/clamp";
import React, { useState } from "react";
import { useCustomPagination } from "../../hooks";
import { useTranslation } from "react-i18next";

const PaginatePills = ({
  noOfPages,
  currentPage,
  onPageChange,
  previousPage,
  nextPage,
  goToPage,
  isManual
}) => {
  const { t } = useTranslation(["Common"]);
  const range = useCustomPagination({
    noOfPages,
    currentPage
  });

  const [jump, setJump] = useState("");

  const onClick = page => () => {
    const newPage = clamp(page, 1, noOfPages);

    window.scrollTo({
      top: 0,
      left: 0
    });

    onPageChange(parseInt(newPage));
  };

  const handleChange = e => {
    let value = parseInt(e.target.value);
    value = isNaN(value) ? 1 : value;
    value = clamp(value, 1, noOfPages);

    setJump(value);
  };

  const go = () => {
    if (isManual) {
      onClick(+jump)();
    } else {
      goToPage(+jump - 1);
    }
  };

  const goTo = page => () => {
    if (isManual) {
      onClick(page)();
    } else {
      goToPage(+page - 1);
    }
  };

  return (
    <nav aria-label="Pagination tabs">
      <ul className="flex flex-wrap items-center justify-center my-6 space-x-2 ">
        <li>
          <button
            onClick={isManual ? onClick(currentPage - 1) : previousPage}
            disabled={isManual ? currentPage === 1 : currentPage === 0}
            className="block aspect-square p-2.5 my-2  leading-tight text-primary bg-white rounded-full hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50"
          >
            <span className="sr-only"> {t("pagination.prev")}</span>
            <svg
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </li>
        {range.map((page, i) =>
          page === "..." ? (
            <li key={i}>
              <span>...</span>
            </li>
          ) : (
            <li key={i}>
              <button
                onClick={goTo(page)}
                className={`py-2 min-w-[40px]  aspect-square my-2 p-2.5 leading-tight  border rounded-full  hover:bg-gray-100 hover:text-gray-700 ${
                  currentPage === (isManual ? page : page - 1)
                    ? "!bg-primary !text-white"
                    : "text-primary bg-white"
                }`}
              >
                {page}
              </button>
            </li>
          )
        )}
        <li>
          <button
            onClick={isManual ? onClick(currentPage + 1) : nextPage}
            disabled={
              isManual
                ? currentPage === noOfPages
                : currentPage === noOfPages - 1
            }
            className={`block p-2.5 my-2 aspect-square  leading-tight text-secondary bg-white rounded-full hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 `}
          >
            <span className="sr-only">{t("pagination.prev")}</span>
            <svg
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </li>
      </ul>

      <div className="flex items-center justify-center my-3 space-x-2">
        <p>{t("pagination.jump")}: </p>
        <input
          className="p-2 rounded-lg text-center min-w-[60px] max-w-[90px]"
          type="number"
          onChange={handleChange}
        />
        <button
          className="p-2 font-medium text-white rounded-lg bg-secondary"
          onClick={go}
        >
          {t("pagination.button.submit")}
        </button>
      </div>
    </nav>
  );
};

export default PaginatePills;
